module.exports = __webpack_public_path__ + "img/iconWeighBridge.ddcf4617.svg";